<template>
  <div class="content-table">
    <template>
      <el-dialog :visible.sync="billTime.show" width="35%" :show-close="false" title="新增地址">
        <div style="display: inline-block;padding-right: 10%;">
          <div class="content-row">
            <div class="col-12 col-6-dialog">
              <div class="col-3">
                <span>
                  <span class="redstar">*</span>收货人姓名
                </span>
              </div>
              <div class="col-9">
                <el-input v-model="consignee" size="medium" placeholder="不能为昵称,X先生,X小姐等" clearable>
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-chat-dot-round"
                    title="电话确认收货人不在现场指定人员代收货"
                  ></i>
                </el-input>
              </div>
            </div>
            <div class="col-12 col-6-dialog">
              <div class="col-3">
                <span>
                  <span class="redstar">*</span>手机号码
                </span>
              </div>
              <div class="col-9">
                <el-input
                  type="text"
                  v-model="phone"
                  size="medium"
                  placeholder="请填写手机号码"
                  validate-event
                  onkeyup="value=value.replace(/[^\d\-\d]/g,'')"
                  show-word-limit
                  clearable
                ></el-input>
              </div>
            </div>
          </div>
          <div class="content-row">
            <div class="col-12 col-6-dialog">
              <div class="col-3">
                <span>
                  <span class="redstar">*</span>所在地区
                </span>
              </div>
              <div class="col-3">
                <el-select
                  v-model="province"
                  @change="selectProvince()"
                  filterable
                  placeholder="请选择省份"
                >
                  <el-option
                    v-for="item in address_datas"
                    :key="item.id"
                    :label="item.cityname"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-3">
                <el-select v-model="city" filterable @change="selectCity()" placeholder="请选择市">
                  <el-option
                    v-for="item in city_data"
                    :key="item.id"
                    :label="item.cityname"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-3">
                <el-select v-model="area" filterable placeholder="请选择区/县">
                  <el-option
                    v-for="item in area_data"
                    :key="item.id"
                    :label="item.cityname"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="content-row">
            <div class="col-12 col-6-dialog">
              <div class="col-3">
                <span>
                  <span class="redstar">*</span>详细地址
                </span>
              </div>
              <div class="col-9">
                <el-input type="textarea" autosize placeholder="请输入内容" v-model="detaile_address"></el-input>
              </div>
            </div>
          </div>
          <div class="content-left-row default-address-row">
            <el-checkbox v-model="checked">设为默认地址</el-checkbox>
          </div>
          <div style="text-align: center;">
            <el-button @click="sub_address()" type="primary" plain size="medium">确认</el-button>
            <el-button @click="billTime.show = false" type="info" plain size="medium">返回</el-button>
          </div>
        </div>
      </el-dialog>
    </template>

    <template>
      <el-dialog :visible.sync="edit_billTime.show" width="35%" :show-close="false" title="修改地址">
        <div style="display: inline-block;padding-right: 10%;">
          <div class="content-row">
            <div class="col-12 col-6-dialog">
              <div class="col-3">
                <span>
                  <span class="redstar">*</span>收货人姓名
                </span>
              </div>
              <div class="col-9">
                <el-input v-model="consignee" size="medium" placeholder="不能为昵称,X先生,X小姐等" clearable>
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-chat-dot-round"
                    title="电话确认收货人不在现场指定人员代收货"
                  ></i>
                </el-input>
              </div>
            </div>
            <div class="col-12 col-6-dialog">
              <div class="col-3">
                <span>
                  <span class="redstar">*</span>手机号码
                </span>
              </div>
              <div class="col-9">
                <el-input
                  type="text"
                  v-model="phone"
                  size="medium"
                  placeholder="请填写手机号码"
                  validate-event
                  onkeyup="value=value.replace(/[^\d\-\d]/g,'')"
                  show-word-limit
                  clearable
                ></el-input>
              </div>
            </div>
          </div>
          <div class="content-row">
            <div class="col-12 col-6-dialog">
              <div class="col-3">
                <span>
                  <span class="redstar">*</span>客户名称
                </span>
              </div>
              <div class="col-9">
                <el-input v-model="staff_name" size="medium" placeholder="请填写客户名称" clearable></el-input>
              </div>
            </div>
          </div>
          <div class="content-row">
            <div class="col-12 col-6-dialog">
              <div class="col-3">
                <span>
                  <span class="redstar">*</span>所在地区
                </span>
              </div>
              <div class="col-3">
                <el-select
                  v-model="province"
                  @change="selectProvince()"
                  filterable
                  placeholder="请选择省份"
                >
                  <el-option
                    v-for="item in address_datas"
                    :key="item.id"
                    :label="item.cityname"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-3">
                <el-select v-model="city" filterable @change="selectCity()" placeholder="请选择市">
                  <el-option
                    v-for="item in city_data"
                    :key="item.id"
                    :label="item.cityname"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-3">
                <el-select v-model="area" filterable placeholder="请选择区/县">
                  <el-option
                    v-for="item in area_data"
                    :key="item.id"
                    :label="item.cityname"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="content-row">
            <div class="col-12 col-6-dialog">
              <div class="col-3">
                <span>
                  <span class="redstar">*</span>详细地址
                </span>
              </div>
              <div class="col-9">
                <el-input type="textarea" autosize placeholder="请输入内容" v-model="detaile_address"></el-input>
              </div>
            </div>
          </div>
          <div class="content-left-row default-address-row">
            <div class="col-3"></div>
            <div class="col-9">
              <el-checkbox v-model="checked">设为默认地址</el-checkbox>
            </div>
          </div>
          <div style="text-align: center;">
            <el-button @click="edit_address()" type="primary" plain size="medium">确认</el-button>
            <el-button @click="edit_billTime.show = false" type="info" plain size="medium">返回</el-button>
          </div>
        </div>
      </el-dialog>
    </template>
    <div class="content_row">
      <p class="title title1" @click="go_back">《《 返回上一级</p>
    </div>
    <div class="content_row">
      <p class="title">选择收货地址</p>
    </div>
    <div class="content_row clear">
      <div
        class="col-3 box_width"
        v-if="url_data.address.length!= 0 "
        v-for="(item,i) in url_data.address"
        :key="i"
        @click="active_address(item)"
        style="position: relative;"
      >
        <div
          class="address_box"
          :class="{address_active: item == select_address}"
          @mouseenter="demo(i)"
          @mouseleave="demo1(i)"
        >
          <div>
            <div class="user margin">
              {{item.province_name}}{{item.city_name}}
              <span>(</span>
              {{item.receiver}}
              <span>)</span>
            </div>
            <div
              class="margin"
            >{{item.province_name}}{{item.city_name}}{{item.area_name}}{{item.addr}}{{item.phone}}</div>
            <div class="edit_address">
              <span
                @click="set_default(item.id)"
                v-if="item.is_default == 0"
                style=" font-size:12px"
                class="defaul_hover"
              >设为默认</span>
              <span
                @click="edit(item.id,item)"
                style="font-size:12px;margin-left:6px"
                class="edit_hover"
              >修改</span>
              <span
                @click="del_addr(item.id)"
                style="font-size:12px;margin-left:6px"
                class="edit_hover"
              >删除</span>
            </div>
          </div>
          <img
            src="static/image/is_default.png"
            class="close"
            :class="{cancer:item.is_default == 0}"
            alt
            style="position: absolute;top: 20px;right: 20px;width: 40px;"
          />
        </div>
      </div>
      <div class="col-3 box_width">
        <div class="address_add" @click="add_address"></div>
      </div>
    </div>
    <div class="content_row" hidden>
      <p class="title">开票信息</p>
    </div>
    <div class="content_row" hidden>
      <div class="fex xs3">
        <div class="y-invoice">是否开票:</div>
        <div class="y-invoice">
          <el-checkbox v-model="change_is" @change="change_is_no(1)">是</el-checkbox>
        </div>
        <div>
          <el-checkbox v-model="change_no" @change="change_is_no(0)">否</el-checkbox>
        </div>
      </div>
    </div>
<!--    change_is ==-->
    <div class="content_row credit" v-show="false">
      <div>
        <div class="row_sty">
          <div class="y-invoince-color">
            发票信息:
            <span v-if="url_data.invoices != null && url_data.invoices != '' ">
              {{url_data.invoices ? url_data.invoices.title : ''}}
              <span
                v-if="url_data.invoices.finvoice != null "
              >{{url_data.invoices ? url_data.invoices.finvoice.value : ''}}</span>
            </span>
          </div>
          <div v-if="url_data.invoice_site != null">
            收票地址:
            {{url_data.invoice_site ? url_data.invoice_site.receiver :''}} {{url_data.invoice_site ? url_data.invoice_site.phone :''}} {{url_data.invoice_site ? url_data.invoice_site.province_name :''}} {{url_data.invoice_site ? url_data.invoice_site.city_name : ''}} {{url_data.invoice_site ? url_data.invoice_site.area_name :''}} {{url_data.invoice_site?url_data.invoice_site.addr :''}}
            <span
              class="addrressColor"
              @click="trueAddress"
            >选择地址</span>
          </div>
        </div>
      </div>
    </div>
    <!--
      选择地址弹窗
    -->
    <el-dialog :visible.sync="billTimeAddres" width="50%" :show-close="false" title="收票地址">
      <div class="content-row action-row action-row1">
        <el-button size="mini" @click="dialogAdderssSub()">确认</el-button>
        <el-button size="mini" @click="billTimeAddres = false">返回</el-button>
      </div>
      <div>
        <el-table
          ref="multipleTable"
          :data="billTimeAddresList"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="rowStyle"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="receiver" label="收货人"></el-table-column>
          <el-table-column label="联系电话/手机">
            <template slot-scope="scope">
              <span>{{scope.row.tel}}</span>
              <span>{{scope.row.phone}}</span>
            </template>
          </el-table-column>
          <el-table-column label="所在地区">
            <template slot-scope="scope">
              <span>{{scope.row.province.name}}</span>
              <span>{{scope.row.city.name}}</span>
              <span>{{scope.row.area.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="addr" label="详细地址"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="billTimeInvoice" width="50%" :show-close="false" title="发票信息">
      <div class="content-row action-row">
        <el-button size="mini" @click="dialogInvoiceSub()">确认</el-button>
        <el-button size="mini" @click="billTimeInvoice = false">返回</el-button>
      </div>
      <div>
        <el-form label-width="139px" class="demo-ruleForm">
          <div class="elBorder">
            <el-form-item label="发票抬头:">
              <el-input v-model="ruleForm.invoiceRise" placeholder="请填写您的发票抬头名称"></el-input>
            </el-form-item>
          </div>
          <div class="elBorder">
            <el-form-item label="发票类型:" style="width:100%">
              <el-select v-model="ruleForm.value" placeholder="请选择发票类型">
                <el-option label="增值税专用发票" value="1"></el-option>
                <el-option label="增值税普通发票" value="2"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="elBorder">
            <el-form-item label="统一社会信用代码:">
              <el-input v-model="ruleForm.invoiceCode" placeholder="请填写同意社会信用代码"></el-input>
            </el-form-item>
          </div>
          <div class="elBorder">
            <el-form-item label="注册地址:">
              <el-input v-model="ruleForm.invoiceAddress" placeholder="请填写注册地址"></el-input>
            </el-form-item>
          </div>
          <div class="elBorder">
            <el-form-item label="注册电话:">
              <el-input
                v-model="ruleForm.invoicePhone"
                placeholder="请填写注册电话"
                onkeyup="value=value.replace(/[^\d\-\d]/g,'')"
              ></el-input>
            </el-form-item>
          </div>
          <div class="elBorder">
            <el-form-item label="开户银行">
              <el-input v-model="ruleForm.invoiceBank" placeholder="请填写开户银行"></el-input>
            </el-form-item>
          </div>
          <div class="elBorder">
            <el-form-item label="银行账号">
              <el-input v-model="ruleForm.invoiceBankAccount" placeholder="请填写银行账号"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!--  选择地址弹窗 end-->
    <div class="content_row">
      <p class="title">支付方式</p>
    </div>
    <div class="content_row credit">
      <div>
        <div class="row_sty">
          <div class="show_border_h" :class="{'show_border': is_payment == 1}" @click="payment(1)">
            <img src="static/image/qianpay.png" align="absmiddle" />
            <span>线下支付</span>
          </div>
          <!-- <div
            class="show_border_h"
            :class="{'show_border': is_payment == 2}"
            style="margin-left:15px;"
            @click="payment(2)"
          >
            <img src="static/image/qianpay.png" align="absmiddle" />
            <span>线上支付</span>
          </div> -->
        </div>

        <el-dialog :visible.sync="dialog_payment" width="50%" :show-close="false" title="账户信息">
          <div class="content-row action-row">
            <el-button size="mini" @click="submit_save(1)">确认</el-button>
            <el-button size="mini" @click="dialog_payment = false">返回</el-button>
          </div>
          <div class="y_elemet_pay">
            <el-form label-width="130px" class="demo-ruleForm">
              <div class="elBorder">
                <el-form-item label="发票抬头">
                  <span>{{url_data.invoices?url_data.invoices.title :''}}</span>
                </el-form-item>
                <el-form-item label="开户银行">
                  <span>{{url_data.invoices?url_data.invoices.bank:''}}</span>
                </el-form-item>
                <el-form-item label="发票类型">
                  <span>{{url_data.invoices?url_data.invoices.finvoice.value :''}}</span>
                </el-form-item>
                <el-form-item label="银行行号">
                  <span>{{url_data.invoices?url_data.invoices.account:''}}</span>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="dialog_payment_to" width="50%" :show-close="false" title="支付账号">
          <div class="content-row action-row">
            <el-button size="mini" @click="submit_save(2)">确认</el-button>
            <el-button size="mini" @click="dialog_payment_to = false">返回</el-button>
          </div>
          <div>
            <el-form label-width="130px" class="demo-ruleForm">
              <div class="elBorder">
                <el-form-item>
                  <span>
                    <img style="width:150px;" src="static/image/payment.png" alt />
                  </span>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </el-dialog>
      </div>
    </div>
    <div class="content_row">
      <p class="title">配送清单</p>
    </div>
    <div class="content_row delivery_row">
      <div class="col-12">
        <el-table
          ref="table"
          :data="url_data.cart"
          class="content-row table_scroll"
          row-key="id"
          default-expand-all
          :tree-props="{children: 'mz', hasChildren: 'hasChildren'}"
          fixed
          @selection-change="changFun"
        >
          <el-table-column width="60">
            <template slot-scope="scope">
              <el-checkbox
                v-if="scope.row.is_must != null"
                :disabled="scope.row.is_must == 1 ? true : false"
                v-model="send_checked[scope.$index]"
              >
                <span style="color:#c39a58">赠</span>
              </el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="spu_name" align="center" border label="产品信息" min-width="120px">
            <template slot-scope="scope">
              <div style="display: flex;flex-direction: column;text-align: left;">
                <div style="display:flex; font-size:12px;">
                  <div style="width:50%;text-align:right;margin-right:5px">{{scope.row.good_name}}</div>
                  <div style="font-size: 20px;">|</div>
                  <div style="width:48%;margin-left:5px">{{scope.row.good_banane}}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="good_spec" border align="center" label="规格" min-width="150px">
            <template slot-scope="scope">
              <div
                style="white-space: pre;text-align:left!important;width:100%;font-family: Courier New;font-size: 13px;"
              >{{scope.row.good_spec}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="weight" border align="center" label="重量/Kg"></el-table-column>
          <el-table-column prop="qty" border align="center" label="数量"></el-table-column>
          <el-table-column prop="price" border align="center" label="单价"></el-table-column>
          <el-table-column prop="sale_price" border align="center" label="销售价"></el-table-column>
          <el-table-column prop="good_pay_amount" border align="center" label="合计金额"></el-table-column>
        </el-table>

        <div class="clearfix delivery_select">
          <span style="width:80px;display:block;float:left;line-height:50px;text-align:center">
            <i style="color:red">*</i> 物流方式
          </span>
          <el-select
            size="small"
            style="width:20%;float:left;margin:1%;"
            clearable
            v-model="delivery_id"
            placeholder="请选择"
          >
            <el-option v-for="item in delivery" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="col-12" style=" text-align:right;margin-top:2%;">
      <span style="width:10%">给商家留言:</span>
      <el-input style="width:92%" v-model="operator"></el-input>
    </div>
    <div class="col-12" style="display:flex">
      <div class="col-8"></div>
      <div class="fex-l col-4 y-order-detail">
        <div style="margin:1% 0;">
          <span
            style="padding-right:2%;"
            v-if="url_data.cart != null "
          >{{url_data.cart.length}}件商品，总商品金额</span>
          <span>￥{{all_price}}</span>
        </div>
        <div style="margin:1% 0;">
          <span style="padding-right:2%;">优惠金额</span>
          <span>￥{{dis_amount}}</span>
        </div>
        <div style="margin:1% 0;">
          <span style="padding-right:2%;">货物净重</span>
          <span>{{all_weight}} Kg</span>
        </div>
        <div style="margin:1% 0;">
          <span style="padding-right:2%;">实付金额</span>
          <span>￥{{final_amount}}</span>
        </div>
      </div>
    </div>
    <div class="content_row sub_order_row">
      <el-button class="sub_order_btn" style="text-align: center;" @click="sub_order" :loading="submitLoading">提交订单</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      props: {
        value: "cityname",
        children: "children",
        label: "cityname"
      },
      billTime: {
        show: false
      },
      edit_billTime: {
        show: false
      },
      data: [],
      consignee: "",
      staff_name: "",
      address: "",
      project_name: "",
      detaile_address: "",
      phone: "",
      tel: "",
      mail: "",
      datas: [],
      express_type: [],
      value: "",
      total: [],
      select_address: "",
      remarks: "",
      operator: "",
      radio: "", //运费付款方式
      adress: "",
      city_data: [],
      area_data: [],
      //选中地址
      provinc: "",
      city: "",
      area: "",
      select_id: "",
      promo_code: "",
      credit: "",
      checked: "",
      province: "",
      address_datas: [],
      edit_id: "",

      url_data: {
        invoices: {
          title: '',
          finvoice: {
            type:'',
            value: ''
          }
        },
        address: [],
        cart: [],
        pay_type: '',
        invoice_site: []
      },
      all_price: "",
      all_weight: "",
      invoices: "",
      change_is: true,
      change_no: "",
      show_invoice: false,

      is_save_type: "",
      /*
      选择地址
      */
      billTimeAddres: false,
      invoice_site: [], //收票数据
      billTimeAddresList: [],
      oldInvionceList: [],
      rowStyle: {
        height: "3rem",
        color: "#575757",
        background: "#E9E9E9",
        "text-align": "center"
      },
      //选择发票弹窗
      billTimeInvoice: false,
      ruleForm: {
        invoiceRise: "", //发票抬头
        value: "", //发票类型
        invoiceCode: "", //社会统一信用代码
        invoiceAddress: "", //注册地址
        invoicePhone: "", //注册电话
        invoiceBank: "", //开户银行
        invoiceBankAccount: "", //开户银行账号
        id: "" //开户银行账号
      },

      // 物流
      delivery_id: "", // 物流的id
      delivery: [], // 物流的数据

      // 支付方式
      is_payment: 1,
      dialog_payment: false,
      dialog_payment_to: false,
      dis_amount: null,
      final_amount: null,
      json_list: "",
      multipleSelection: [],
      send_checked: [],
      table_all_data: [],


      submitLoading : false
    };
  },
  mounted() {
    this.view();
  },
  watch: {},
  methods: {
    view() {
      var params;
      if (this.$route.query.type != null) {
        params = {
          confirm_type: 2,
          goods: sessionStorage.getItem("detail_data")
        };
      } else {
        params = {
          id: sessionStorage.getItem("ids").split(",")
        };
      }
      this.$axios({
        method: "post",
        url: "/index/order/confirm_order",
        params: params
      })
        .then(res => {
          if (res.data.status == "ok") {
            this.url_data = res.data.data;
            this.url_data.invoices = res.data.data.invoices || {
              title: '',
              finvoice: {
                type:'',
                value: ''
              }
            }
            this.url_data.cart.forEach(element => {
              this.table_all_data.push(element);
              if (element.mz != null) {
                element.mz.forEach(item => {
                  item.ware_id = { ware_id: element.ware_id.ware_id };
                  item.pid = element.good_itemid;
                  this.table_all_data.push(item);
                });
              }
            });
            this.table_all_data.forEach((item, index) => {
              if (item.is_must == 1) {
                this.send_checked[index] = true;
              } else {
                this.send_checked[index] = false;
              }
            });
            this.all_weight = this.url_data.total_weight;
            this.all_price = this.url_data.total_amount;
            this.dis_amount = this.url_data.dis_amount;
            this.final_amount = this.url_data.final_amount;
            //获取选中地址
            for (let i = 0; i < this.url_data.address.length; i++) {
              if (this.url_data.address[0] == null) {
              } else {
                if (this.url_data.address[i].is_default == 1) {
                  this.select_address = this.url_data.address[i];
                  this.select_id = this.url_data.address[i].id;
                }
              }
            }
            this.credit = this.url_data.pay_type[1]; //支付方式
            var is_has_default = 0;
            this.url_data.invoice_site ? '' :this.url_data.invoice_site = []
            for (let i = 0; i < this.url_data.invoice_site.length; i++) {
              if (this.url_data.invoice_site[i].is_default == 1) {
                this.invoice_site = this.url_data.invoice_site[i];
                is_has_default = 1;
              }
            }
            if (is_has_default == 0) {
              this.invoice_site = this.url_data.invoice_site[0];
            } //取发票地址
            var is_has_defaults = 0;
            this.url_data.invoices ? '' :this.url_data.invoices = []
            for (let i = 0; i < this.url_data.invoices.length; i++) {
              if (this.url_data.invoices[i].is_default == 1) {
                this.invoices = this.url_data.invoices[i];
                is_has_defaults = 1;
              }
            }
            if (is_has_defaults == 0 && this.url_data.invoices[0]) {
              this.invoices = this.url_data.invoices[0];
            } //取发票信息
            if (res.data.data.delivery != undefined && res.data.data.delivery != "") {
              this.delivery = res.data.data.delivery;
            }
          } else {
            setTimeout(() => {
              this.$message1(res.data.msg);
              window.history.back(-1);
            }, 800);
            return;
          }
        })
        .catch(err => {});
      this.$axios({
        method: "post",
        url: "/index/customer_addr/city",
        params: {}
      })
        .then(res => {
          this.address_datas = res.data.data;
        })
        .catch(err => {});

      //判断发票信息完整不完整
      this.$axios({
        method: "post",
        url: "/index/order/is_save",
        params: {}
      })
        .then(res => {
          this.is_save_type = res.data.data.data;
        })
        .catch(err => {});

    this.selchecked(); //每次更新了数据，触发这个函数即可。

    },
    selchecked() {
      if (this.url_data.cart[0]) this.$refs.table.toggleRowSelection(this.url_data.cart[0], true);
    },

    //新增地址
    add_address() {
      this.billTime.show = true;
      console.log(this.billTime.show)
      this.consignee = "";
      this.phone = "";
      this.tel = "";
      this.project_name = "";
      this.staff_name = "";
      this.province = "";
      this.city = "";
      this.area = "";
      this.detaile_address = "";
      this.checked = false;
    },
    sub_address() {
      var data = {
        province: this.province,
        city: this.city,
        area: this.area,
        receiver: this.consignee,
        addr: this.detaile_address,
        phone: this.phone,
        tel: this.tel,
        project_name: this.project_name,
        is_default: this.checked == true ? 1 : false
      };
      this.$axios({
        method: "post",
        url: "/index/customer_addr/add",
        params: {
          data: data
        }
      })
        .then(res => {
          this.$message1(res.data.msg);
          if (res.data.status == "ok") {
            this.billTime.show = false;
            this.view();
          }
        })
        .catch(err => {});
    },
    // 修改地址
    edit(id, item) {
      var pro = "";
      var cit = "";
      var are = "";
      this.edit_billTime.show = true;
      this.$axios({
        method: "post",
        url: "index/customer_addr/info",
        params: {
          id: id
        }
      })
        .then(res => {
          this.edit_id = res.data.data.id;
          this.consignee = res.data.data.receiver;
          this.phone = res.data.data.phone;
          this.tel = res.data.data.tel;
          this.project_name = res.data.data.project_name;
          this.staff_name = res.data.data.custom_name;
          this.province = parseInt(res.data.data.province);
          this.selectProvince();
          this.city = parseInt(res.data.data.city);
          this.selectCity();
          this.area = parseInt(res.data.data.area);
          this.detaile_address = res.data.data.addr;
          this.checked = res.data.data.is_default == 1 ? true : false;
          this.addressShow = true;
        })
        .catch(err => {});
    },
    edit_address() {
      var data = {
        province: this.province,
        city: this.city,
        area: this.area,
        receiver: this.consignee,
        addr: this.detaile_address,
        phone: this.phone,
        tel: this.tel,
        project_name: this.project_name,
        is_default: this.checked == true ? 1 : false,
        id: this.edit_id
      };
      this.$axios({
        method: "post",
        url: "/index/customer_addr/save",
        params: {
          data: data
        }
      })
        .then(res => {
          this.$message1(res.data.msg);
          if (res.data.status == "ok") {
            this.edit_billTime.show = false;
          }
        })
        .catch(err => {});
    },
    // 默认状态
    set_default(id) {
      this.$axios({
        method: "post",
        url: "index/customer_addr/set_default",
        params: {
          id: id,
          status: 1
        }
      })
        .then(res => {
          this.view();
          this.$message(res.data.msg);
        })
        .catch(err => {});
    },
    //选中地址
    active_address(select_address) {
      this.select_address = select_address;
      this.select_id = select_address.id;
    },
    //选择地址弹窗保存
    dialogInvoiceSub() {
      this.$axios({
        method: "post",
        url: "/index/invoices/update",
        params: {
          title: this.ruleForm.invoiceRise,
          addr: this.ruleForm.invoiceAddress,
          tel: this.ruleForm.invoicePhone,
          bank: this.ruleForm.invoiceBank,
          account: this.ruleForm.invoiceBankAccount,
          unified_social_code: this.ruleForm.invoiceCode,
          finvoice_type: this.ruleForm.value,
          id: this.ruleForm.id
        }
      })
        .then(res => {
          if (res.data.status == "ok") {
            this.$message1("保存成功");
            this.billTimeInvoice = false;
            this.view();
          } else {
            this.$message1("发票信息未填写完整");
          }
        })
        .catch(err => {});
    },

    changFun(val) {
      this.multipleSelection = val;
    },
    submit_save(e) {
      this.submitLoading = true
      if (e == 1) {
        this.dialog_payment = false;
      } else {
        this.dialog_payment_to = false;
      }
      let obj = [];
      this.send_checked.forEach((element, index) => {
        if (element == true) {
          obj.push(this.table_all_data[index]);
        }
      });
      let datamsg = this.url_data.cart.concat(obj);
      let jsonone = [];
      let i;
      for (i in datamsg) {
        jsonone.push({
          good_itemid: datamsg[i].good_itemid,
          qty: datamsg[i].qty,
          ware_id: datamsg[i].ware_id.ware_id,
          pid: datamsg[i].is_must == null ? 0 : datamsg[i].pid
        });
      }
      if (this.$route.query.type != null) {
        var invoice_info = {
          id: this.url_data.invoice_site.id,
          receiver: this.url_data.invoice_site.receiver,
          province_name: this.url_data.invoice_site.province_name,
          city_name: this.url_data.invoice_site.city_name,
          area_name: this.url_data.invoice_site.area_name,
          addr: this.url_data.invoice_site.addr
        };
        var invoicesite_info = this.url_data.invoices;
        this.$axios({
          method: "post",
          url: "/index/order/order_save",
          params: {
            type: 2,
            remark: this.operator, //留言
            json: JSON.stringify(jsonone),
            addr: this.select_address.addr,
            addrId: this.select_id,
            is_is_invoice: this.change_is == true ? 1 : 2,
            invoice_info,
            invoicesite_info,
            delivery: this.delivery_id,
            pay_type: this.is_payment
          }
        })
          .then(res => {
            this.$message1(res.data.msg);
            if (res.data.status == "ok") {
              this.$router.push({
                path: "/personal/index"
              });
            }
            if (res.data.status == "temp") {
              this.open();
              this.$message1(res.data.msg);
            }
          })
          .finally(()=>{
            this.submitLoading = false
          })
          .catch(err => {});
      } else {
        var invoice_info = {
          id: this.url_data.invoice_site.id,
          receiver: this.url_data.invoice_site.receiver,
          province_name: this.url_data.invoice_site.province_name,
          city_name: this.url_data.invoice_site.city_name,
          area_name: this.url_data.invoice_site.area_name,
          addr: this.url_data.invoice_site.addr,
          phone: this.url_data.invoice_site.phone
        };
        var invoicesite_info = this.url_data.invoices;
        this.$axios({
          method: "post",
          url: "/index/order/order_save",
          params: {
            type: 1,
            remark: this.operator, //留言
            json: JSON.stringify(jsonone),
            addrId: this.select_id,
            is_is_invoice: this.change_is == true ? 1 : 2,
            invoice_info,
            invoicesite_info: this.url_data.invoices,
            delivery: this.delivery_id,
            pay_type: this.is_payment
          }
        })
          .then(res => {
            if (res.data.status == "ok") {
              this.$axios({
                method: "post",
                url: "/index/cart/get_qty"
              })
                .then(res => {
                  this.$store.dispatch("setQty", res.data.data);
                  sessionStorage.setItem(
                    "qty",
                    this.$store.getters.getcurrentQty
                  );
                })
                .catch(err => {});
              this.$message1(res.data.msg);
              this.$router.push({
                path: "/personal/index"
              });
            } else {
              this.$message1("提交失败！");
            }
            if (res.data.status == "temp") {
              this.open();
              this.$message1(res.data.msg);
            }
          })
          .finally(()=>{
            this.submitLoading = false
          })
          .catch(err => {});
      }
    },
    sub_order() {
      if (this.select_id == "") {
        this.$message1("请选择收货地址");
        return;
      }
      if (this.is_payment == 0) {
        this.$message1("请选择支付方式");
        return;
      }
      if (this.delivery_id == "") {
        this.$message1("请选择物流方式");
        return;
      }
      if (this.is_save_type.type == 2) {
        this.billTimeInvoice = true;
        if (this.is_save_type.id != null) {
          this.ruleForm.invoiceRise = this.url_data.invoices.title;
          this.ruleForm.value = this.url_data.invoices.finvoice.type + "";
          this.ruleForm.invoiceCode = this.url_data.invoices.unified_social_code;
          this.ruleForm.invoiceAddress = this.url_data.invoices.addr;
          this.ruleForm.invoicePhone = this.url_data.invoices.tel;
          this.ruleForm.invoiceBank = this.url_data.invoices.bank;
          this.ruleForm.invoiceBankAccount = this.url_data.invoices.account;
          this.ruleForm.id = this.url_data.invoices.id;
        }
      } else {
        
        if (this.is_payment == 1) {
          this.dialog_payment = true;
        } else {
          this.dialog_payment_to = true;
        }
      }
    },

    // 地址选择
    selectProvince() {
      var that = this;
      this.address_datas.forEach(function(currentVal, index) {
        if (that.province == currentVal.id) {
          that.city_data = currentVal.children;
        }
      });
      this.city = "";
      this.area = "";
    },
    selectCity() {
      var that = this;
      this.city_data.forEach(function(currentVal, index) {
        if (that.city == currentVal.id) {
          that.area_data = currentVal.children;
        }
      });
      this.area = "";
    },
    del_addr(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios({
            method: "post",
            url: "/index/customer_addr/del",
            params: {
              id: id
            }
          })
            .then(res => {
              this.$message1(res.data.msg);
              this.view();
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
    change_is_no(e) {
      if (e == 0) {
        if ((this.change_no = true)) {
          this.change_is = false;
          this.show_invoice = false;
        } else {
        }
      } else {
        if ((this.change_is = true)) {
          this.change_no = false;
          this.show_invoice = true;
        } else {
        }
      }
    },

    //选择收票地址
    trueAddress() {
      this.billTimeAddres = true;
      this.$axios({
        method: "post",
        url: "/index/Customer_addr/index",
        params: {}
      })
        .then(res => {
          this.billTimeAddresList = res.data.data.list;
        })
        .catch(err => {});
    },
    dialogAdderssSub() {
      this.url_data.invoice_site.receiver = this.oldInvionceList[0].receiver;
      this.url_data.invoice_site.phone = this.oldInvionceList[0].phone;
      this.url_data.invoice_site.province_name = this.oldInvionceList[0].province.name;
      this.url_data.invoice_site.city_name = this.oldInvionceList[0].city.name;
      this.url_data.invoice_site.area_name = this.oldInvionceList[0].area.name;
      this.url_data.invoice_site.addr = this.oldInvionceList[0].addr;
      this.url_data.invoice_site.id = this.oldInvionceList[0].id;
      this.billTimeAddres = false;
    },
    handleSelectionChange(item) {
      this.oldInvionceList = item;
    },
    payment(e) {
      this.is_payment = e;
    },
    go_back() {
      window.history.back(-1);
    }
  }
};
</script>
<style lang="less" scoped>
.xs3 {
  width: 30%;
}
.y-invoice {
  padding-right: 5%;
}
.fex-l {
  display: flex;
  flex-direction: column; // row-reverse;
}
.fex-r {
  display: flex;
  justify-content: space-between;
}
.fex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.col-6-dialog span,
.col-6-dialog .el-input,
.col-12-dialog span,
.col-12-dialog .el-input,
.col-12-dialog .el-textarea {
  float: left;
  line-height: 2rem;
}
.col-12-dialog .col-10 {
  margin: 0;
}
.col-6-dialog .col-3 span {
  float: right;
  margin-right: 10%;
  line-height: 2rem;
}
.col-6-dialog .col-3 .redstar {
  float: left;
  display: contents;
}
.el-icon-chat-dot-round {
  color: red;
  cursor: pointer;
}
.action-row {
  width: 22%;
  float: right;
  margin: -7% 4% 0 0;
}
.action-row1 {
  margin: -6.5% 4% 0 0;
}
.address-row {
  margin-left: 4%;
}
.content-table {
  font-size: 14px;
}
.title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 15px;
  margin-top: 15px;
}
.title1 {
  font-size: 14px;
  color: #c39a58;
}
.good_datails {
  text-align: left;
  margin-left: 80px;
}
.y-order-detail {
  text-align: right;
}
.content_row {
  text-align: left;
}
.address_box {
  background: url("/static/image/weixuan.png") no-repeat;
  margin: 5% 5% 5% 0;
  min-height: 100px;
  background-size: 100% 100%;
  padding: 2%;
}
.address_active {
  margin: 5%;
  min-height: 100px;
  background: url("/static/image/red_box.png") no-repeat;
  background-size: 100% 100%;
  padding: 2%;
}
.address_add {
  margin: 5%;
  min-height: 100px;
  background: url("/static/image/xinzeng.png") no-repeat;
  background-size: 100% 100%;
  padding: 2%;
}
.credit {
  border: 1px solid rgba(226, 223, 223, 1);
  padding: 1%;
  margin-top: 2%;
}
.delivery_row {
  border: 1px solid rgba(226, 223, 223, 1);
  // padding: 1%;
  overflow: auto;
  zoom: 1;
}

.col-9 {
  width: 74.5%;
  border-left: 1px solid rgba(226, 223, 223, 1);
}
p {
  margin: 0px;
  font-size: 14px;
  padding-right: 3%;
}
.color {
  color: red;
}
.tips {
  margin-top: 5%;
}
.el-dialog-row {
  height: 50px;
}
.el-input__inner {
  height: 10px;
}
.clear {
  overflow: auto;
  zoom: 1;
}
textarea {
  resize: none;
  width: 76%;
  height: 60px;
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(221, 221, 221, 1);
}
.good_pic {
  width: 65px;
  height: 70px;
}
.row_sty {
  display: inline-block;
}
.box_width {
  cursor: pointer;
  width: 20%;
  position: relative;
}
.actual_row {
  width: 100%;
  height: 125px;
  background: rgba(244, 244, 244, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  margin-top: 20px;
}
.sub_order_row {
  margin: 4%;
  margin-right: 0%;
  text-align: right;
}
.sub_order_btn {
  width: 145px;
  height: 45px;
  background: rgba(219, 33, 45, 1);
  border-radius: 4px;
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
}
.user {
  font-size: 15px;
  border-bottom: 1px solid rgba(221, 221, 221, 1);
  font-weight: 500;
  height: 30px;
  line-height: 30px;
}
.margin {
  margin-left: 5%;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.y-invoince-color {
  margin-bottom: 1%;
}
.edit_address {
  // text-align: right;
  // margin-top: 10px;
  // margin-right: 5px;
  position: absolute;
  bottom: 25px;
  right: 30px;
}
.default-address-row {
  margin: 1% 0 3% 12%;
}
.delivery_mode_sty {
  margin-left: 9%;
  margin-top: 5%;
}
.bottom_box {
  width: 99.5%;
  height: 125px;
  background: rgba(244, 244, 244, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  margin-top: 20px;
}
.credit_back {
  background: url("/static/image/beijingtu.png") no-repeat;
  margin-left: 10px;
  margin-top: 5px;
  padding: 7px 30px 10px 29px;
}
.pay_money {
  font-size: 24px;
  font-weight: bold;
  color: rgba(227, 16, 30, 1);
}
.delivery_address {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  text-align: right;
}
.pay_tips {
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 25px;
}
</style>
<style lang="less" >
.el-dialog_row_input .el-input__inner {
  height: 35px;
  border-radius: 0px;
}
.delivery_select .el-input__inner {
  height: 35px;
  border-radius: 0px;
  border: 1px solid #c39a58;
}
.delivery_select .el-input__suffix {
  background: #c39a58;
  right: 0px;
  width: 26%;
}

.el-dialog_row_input .el-input__suffix .el-input__icon {
  line-height: 35px;
}
.delivery_select .el-input.is-focus .el-input__inner {
  border: 1px solid #c39a58;
}
.delivery_select .el-input__inner:focus {
  border: 1px solid #c39a58;
}
.delivery_select .el-input__inner {
  border: 1px solid #c39a58;
}
.delivery_select .el-input__inner:hover {
  border: 1px solid #c39a58;
}
.del_address {
  display: block;
}
.cancer {
  display: none;
}
.defaul_hover:hover {
  color: rgba(227, 16, 30, 1);
}
.edit_hover:hover {
  color: rgba(227, 16, 30, 1);
}

/*
收票地址
*/
.addrressColor {
  color: #c39a58;
  padding: 5px 15px;
  cursor: pointer;
}
.el-select {
  width: 100%;
}
/*
支付方式
*/

.show_border_h {
  border: 1px solid #ccc;
  padding: 10px 15px;
  float: left;
  cursor: pointer;
}
.show_border {
  border: 2px solid #c39a58;
  background: url("/static/icon/active.png") right no-repeat;
  // background: url("/static/icon/active.png") right no-repeat;
  background-position-y: 31px;
}
.y_elemet_pay .el-form-item__label {
  font-weight: bold;
  background: #cead77;
}
.y_elemet_pay .el-form-item__content {
  border: 1px solid #ccc;
  padding-left: 10px;
  line-height: 35px;
}
.col-12 {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Cart/order.vue